import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function usePropertyCreate() {
  const axiosPrivate = useAxiosPrivate();
  return useMutation({
    mutationFn: (request) => {
      return axiosPrivate({
        method: "POST",
        url: "Property",
        data: request,
      });
    },
  });
}

export default usePropertyCreate;
